var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "modules-wrap" },
    [
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.tableData,
            height: "100%",
            border: true,
            "header-cell-style": { color: "#333333", background: "#EFF6FF" },
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "index",
              align: "center",
              width: "100",
              label: "序号",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "logistics_name",
              "min-width": "150",
              "show-overflow-tooltip": "",
              align: "center",
              label: "城市仓",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(scope.row.logistics_name || "-")),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "number", align: "center", label: "件数" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "tonnage_num",
              align: "center",
              label: "重量（吨）",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "total_amount",
              align: "center",
              label: "金额（万元）",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "user_count",
              align: "center",
              label: "下单客户人数",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "avg_order", align: "center", label: "人均下单数" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }